import { Component, h, ComponentInterface, State, Element } from '@stencil/core';
import { HTMLStencilElement } from '@stencil/core/internal';
import { guid } from 'utils';

@Component({
	tag: 'kdx-featured-articles',
	styleUrl: 'kdx-featured-articles.scss'
})
export class StFeaturedArticles implements ComponentInterface {

	@State() guid: string = guid();
	@State() mobileContentCopy: string = '';

	@Element() hostElement: HTMLStencilElement;

	componentWillLoad() {
		const desktopContent = this.hostElement.querySelector('.layout-links');

		if (desktopContent) {
			this.mobileContentCopy = desktopContent.innerHTML;
		}
	}

	render() {
		return (
		<section class="kdx-featured-articles" id={`kdx-featured-article-${this.guid}`} aria-label="featured articles">
			<slot />
		</section>
		);
	}
}